import { DELIVERY_TYPE, PICKUP_TYPE } from '../webStorage/keys/sessionKeys';
import { getCountryCode } from './getCountryCode';

export const getEligibleOrderTypes = () => {
  return 7;
};

export const getDefaultOrderType = () => {
  const countryCode = getCountryCode();
  if ((countryCode == 'id' || countryCode == 'th')) {
    // default is set for pickup in indonesia and thailand
    return PICKUP_TYPE;
  }
  const eligibleOrderType = getEligibleOrderTypes();
  if ((eligibleOrderType & 2) === 2) {
    return DELIVERY_TYPE;
  }
};
